/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Packages_HintInputs */

const en_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book your next session from an active package.`)
};

const es_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva tu siguiente sesión desde un paquete activo.`)
};

const de_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen Sie Ihre nächste Golfstunde aus einem aktiven Paket.`)
};

const zh_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过有效套餐预订你的下一次课程。`)
};

const ar_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز جلستك التالية من باقة نشطة.`)
};

const fr_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez votre prochaine séance à partir d'un forfait actif.`)
};

const vi_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi tiếp theo từ gói đang hoạt động.`)
};

const sw_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya kipindi chako kijacho kutoka kwenye kifurushi kinachotumika.`)
};

const th_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองเซสชันถัดไปของคุณจากแพ็คเกจที่ใช้งานอยู่`)
};

const bs_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite sljedeću sesiju iz aktivnog paketa.`)
};

const ja_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブなパッケージから次のセッションを予約します。`)
};

const ko_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용 중인 패키지로 다음 세션을 예약하세요.`)
};

const pt_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserve sua próxima sessão a partir de um pacote ativo.`)
};

const it_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota la tua prossima sessione da un pacchetto attivo.`)
};

const sv_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka nästa session från ett aktivt paket.`)
};

const nl_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek je volgende sessie vanuit een actief pakket.`)
};

const da_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestil din næste session fra en aktiv pakke.`)
};

const nb_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill neste økt fra en aktiv pakke.`)
};

const fi_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa seuraava tunti aktiivisesta paketista.`)
};

const pl_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj następną sesję z aktywnego pakietu.`)
};

const ru_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забронируйте следующее занятие из активного пакета.`)
};

const tr_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir sonraki dersinizi aktif paketinizden ayırtın.`)
};

const hi_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने अगले सत्र को सक्रिय पैकेज से बुक करें।`)
};

const id_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan sesi Anda berikutnya dari paket aktif.`)
};

const ms_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah sesi seterusnya daripada pakej aktif anda.`)
};

const cs_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervujte si další lekci z aktivního balíčku.`)
};

const el_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε την επόμενη συνεδρία σας από ένα ενεργό πακέτο.`)
};

const he_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמינו את המפגש הבא מתוך חבילה פעילה.`)
};

const af_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek jou volgende sessie uit 'n aktiewe pakket.`)
};

const hu_booking_packages_hint = /** @type {(inputs: Booking_Packages_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglald le a következő alkalmat egy aktív csomagból.`)
};

/**
* | output |
* | --- |
* | "Book your next session from an active package." |
*
* @param {Booking_Packages_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_packages_hint = /** @type {((inputs?: Booking_Packages_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Packages_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_packages_hint(inputs)
	if (locale === "de") return de_booking_packages_hint(inputs)
	if (locale === "zh") return zh_booking_packages_hint(inputs)
	if (locale === "ar") return ar_booking_packages_hint(inputs)
	if (locale === "fr") return fr_booking_packages_hint(inputs)
	if (locale === "vi") return vi_booking_packages_hint(inputs)
	if (locale === "sw") return sw_booking_packages_hint(inputs)
	if (locale === "th") return th_booking_packages_hint(inputs)
	if (locale === "bs") return bs_booking_packages_hint(inputs)
	if (locale === "ja") return ja_booking_packages_hint(inputs)
	if (locale === "ko") return ko_booking_packages_hint(inputs)
	if (locale === "pt") return pt_booking_packages_hint(inputs)
	if (locale === "it") return it_booking_packages_hint(inputs)
	if (locale === "sv") return sv_booking_packages_hint(inputs)
	if (locale === "nl") return nl_booking_packages_hint(inputs)
	if (locale === "da") return da_booking_packages_hint(inputs)
	if (locale === "nb") return nb_booking_packages_hint(inputs)
	if (locale === "fi") return fi_booking_packages_hint(inputs)
	if (locale === "pl") return pl_booking_packages_hint(inputs)
	if (locale === "ru") return ru_booking_packages_hint(inputs)
	if (locale === "tr") return tr_booking_packages_hint(inputs)
	if (locale === "hi") return hi_booking_packages_hint(inputs)
	if (locale === "id") return id_booking_packages_hint(inputs)
	if (locale === "ms") return ms_booking_packages_hint(inputs)
	if (locale === "cs") return cs_booking_packages_hint(inputs)
	if (locale === "el") return el_booking_packages_hint(inputs)
	if (locale === "he") return he_booking_packages_hint(inputs)
	if (locale === "af") return af_booking_packages_hint(inputs)
	if (locale === "hu") return hu_booking_packages_hint(inputs)
	return en_booking_packages_hint(inputs)
});